import React from "react";

interface Props {
  name?: string;
  /** Fallback for the initial when the user has no name. */
  email?: string | null;
  onClick?: () => void;
}

export const UserIcon: React.FC<Props> = ({ name, email, onClick }) => {
  const initial = (name || email || "").charAt(0).toUpperCase();
  return (
    <div
      className="inline-flex items-center justify-center min-w-[32px] rounded-[32px] px-3 py-[7px] bg-secondary-button-background cursor-pointer"
      onClick={onClick}
    >
      <span className="text-[14px] font-semibold leading-[18px] text-secondary-button-foreground">
        {initial}
      </span>
    </div>
  );
};
